import { shallowRef, watch } from 'vue'

import type { Nullable } from '@/types'
import { useGoogleMaps } from '@/use'

const autocomplete =
  shallowRef<Nullable<google.maps.places.AutocompleteService>>(null)

export default function usePlacesAutocomplete() {
  const { loaded } = useGoogleMaps()
  watch(
    loaded,
    async (v) => {
      if (v === false) return
      autocomplete.value = new google.maps.places.AutocompleteService()
    },
    { immediate: true },
  )
  function get(): Promise<google.maps.places.AutocompleteService> {
    return new Promise((resolve) => {
      if (autocomplete.value !== null) {
        resolve(autocomplete.value)
        return
      }
      const unwatch = watch(autocomplete, (v) => {
        if (v === null) return
        unwatch()
        resolve(v)
      })
    })
  }
  return { autocomplete, get }
}
